import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { Model } from '../../../model/model';
import { WizConstants } from '../../../model/constants';
import { DATA_KIND } from '../../../model/enums';
import { FunctionObj } from '../../../vo/workingdata/function-obj';
import { WidgetLine } from '../../../vo/workingdata/widget-line.obj';
import { BaselineEngine } from '../../workingdata/baseline.engine';
import { FunctionCoreEngine } from '../function.core.engine';
import { MeasModeItem } from '../measure.mode.obj';
import { FreedataValueVO } from '../../../vo/core/freedatavalue.vo';

/**
 * opérateurs logiques
 */
export class LogicalFunctions {


  public static functions(model: Model): FunctionObj[] {
      const funcArr: FunctionObj[] = [];
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'IF', [DATA_KIND.BOOLEAN, DATA_KIND.STRING, DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'OR', [DATA_KIND.BOOLEAN], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'AND', [DATA_KIND.BOOLEAN], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'PREFER', [DATA_KIND.MEASURE], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'NOT', [DATA_KIND.BOOLEAN]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'MANDATORY', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'EMPTY', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'REQUIRED', [DATA_KIND.MEASURE], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'REQUIREDFILTERS', [DATA_KIND.STRING], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'COMPLETION', [DATA_KIND.STRING], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'UNIQUE', [DATA_KIND.STRING]));
       funcArr.push(new FunctionObj(model, FunctionObj.KIND_LOGICAL, 'IFS', [DATA_KIND.MEASURE], true));
      return funcArr;
  }

  /**
   * test logique SI (retourne 1(true) ou 0 (false)
   *
   * @param mmi Etape de calcul concernée
   */
  public static IF(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0];
    // contrôle de cohérence
    if (param1.isErr) {
      // console.log('paramHasError', param1);
      mmi.r = null; // param1.result;
      mmi.isErr = true;
    } else {
      // param 2 et 3 optionnels
      let resTrue = '1';
      let resFalse = '0';

      if (mmi.c.length > 1) {
        resTrue = mmi.c[1].r;
      }
      if (mmi.c.length > 2) {
        resFalse = mmi.c[2].r;
      }
      const val: number = Number(param1.r);
      if (val === 1) {
        mmi.r = resTrue;
      } else {
        mmi.r = resFalse;
      }
    }
   }

  /**
   * retourne true si tout est true (1)
   *
   * @param mmi Etape de calcul concernée
   */
  public static AND(mmi: MeasModeItem, fei: FeiVO): void {
    // console.log('AND FUNC', mmi);
    let result: string = '1';
    const fixedMmi: string[] = FunctionCoreEngine.collectToMmiContent(fei?.model, mmi);
    fixedMmi?.forEach((str: string) => {
      if (str !== '1') {
        result = '0';
      }
    });
    mmi.r = result;
  }

  /**
   * retourne true si tout est true (1)
   *
   * @param mmi Etape de calcul concernée
   */
  public static OR(mmi: MeasModeItem, fei: FeiVO): void {
    let result: string = '0';
    const fixedMmi: string[] = FunctionCoreEngine.collectToMmiContent(fei?.model, mmi);
    fixedMmi?.forEach((str: string) => {
      if (str === '1') {
        result = '1';
      }
    });
    mmi.r = result;
  }

  /**
   * inverse le booleen
   *
   * @param mmi Etape de calcul concernée
   */
   public static NOT(mmi: MeasModeItem): void {
    let result: string = '0';
    const param1: MeasModeItem = mmi.c[0]; // valeurs (un boolean)
    if (param1.r === '1') {
      result = '0';
    } else {
      result = '1';
    }

    mmi.r = result;
  }

  /**
   * prend le 1er si existe, sinon le deuxième
   *
   * @param mmi Etape de calcul concernée
   */
  public static PREFER(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): void {
    const param1: MeasModeItem = mmi.c[0]; // préféré
    const param2: MeasModeItem = mmi.c[1]; // deuxième choix

    let result: any = null;
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei?.model, mmi);
    }

    let str: string;
    for(let i= 0; i < fixedMmi?.length; i++) {
      if(!!result) {
        break;
      }
      str = fixedMmi[i];
      if(!!str) {
        result = str;
      }
    }

    mmi.r = result;
    // contrôle de cohérence
    // if (!!param1.r) {
    //   // console.log('paramHasError', param1);
    //   mmi.r = param1.r;
    // } else {
    //   mmi.r = param2.r;
    // }
  }

  /**
   * dénombre si correspondance de critère
   * @param mmi Etape de calcul concernée
   */
  public static MANDATORY(mmi: MeasModeItem): boolean {
    // console.log('MANDATORY FUNC', mmi);
    let result: boolean = true;
    const valExist: string = mmi.c[0].r;
    if (!valExist) {
      result = false;
    }

    if (!!result ) {
      mmi.r = '1';
    } else {
      mmi.r = '0';
    }

    return result;
  }

  /**
   * retourne true si le champ et vide / null
   * @param mmi Etape de calcul concernée
   */
  public static EMPTY(mmi: MeasModeItem): boolean {
    // console.log('EMPTY FUNC', mmi);
    let result: boolean = true;
    const valExist: string = mmi.c[0].r;
    if (!!valExist) {
      result = false;
    }

    if (!!result ) {
      mmi.r = '1';
    } else {
      mmi.r = '0';
    }

    return result;
  }

  /**
   * return true si tout est non-null pour des Mesures
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static REQUIRED(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): boolean {
    let result: boolean = true;
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    fixedMmi?.forEach((str: string) => {
      if(str === null || str === undefined) {
        result = false;
        return;
      } 
    });
    if (!!result ) {
      mmi.r = '1';
    } else {
      mmi.r = '0';
    }
    return result;
  }

  /**
   * return true si tout est non-null, sur des éléments de Clé ou de Filtre
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static REQUIREDFILTERS(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): boolean {
    let result: boolean = true;
    
    const fixedMmi: string[] = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);

    fixedMmi?.forEach((key: string) => {
      
      // la valeur chronocode ou FDV pour cette baseline
      let akmFDVCell = BaselineEngine.checkFDVCell(fei, line.bl, key, WizConstants.FIELD_CODE);
      if(!akmFDVCell) {
        result = false;
        return;
      }
      
    });
    if (!!result ) {
      mmi.r = '1';
    } else {
      mmi.r = '0';
    }
    return result;
  }

  /**
   * return le % de completion sur les éléments passé en param (pas de prise en compte du 0)
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static COMPLETION(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): void {
    let result: string = '0';
    let fixedMmi: string[] = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    // console.log('compl', fixedMmi);
    let total: number = fixedMmi?.length || 0;
    let ok: number = 0;
    if(total > 0) {
      fixedMmi?.forEach((key: string) => {
        if(!!key) { // pas de prise en compte des 0
          
          if(fei.keyMap.has(key)) { // une filter / une clé
            let akmFDVCell = BaselineEngine.checkFDVCell(fei, line.bl, key, WizConstants.FIELD_CODE);
            if(akmFDVCell) {
              ok++;
            }
          } else {
            if(key !== '0') {
              ok++;
            }
          }
        }  
      });

      result =  (ok*100/total).toFixed(2);
    }
    mmi.r = result;
  }

  /**
   * champ unique (sur un FDV)
   * @param mmi Etape de calcul concernée
   */
  public static UNIQUE(mmi: MeasModeItem, line: WidgetLine, fei: FeiVO): boolean {
    const from: string = mmi.c[0].r; // le champ cible à l'origine du déclenchement
    // const to: string = mmi.c[1].r; // le champ cible   
    
    let result: boolean = true;

    let fdv: FreedataValueVO = line as FreedataValueVO;
    let brothers: FreedataValueVO[] = fdv.getParentFDVO().getValuesVO();
    let existSet: Map<string, number> = new Map();
    brothers.forEach(bro => {
      existSet.set(bro.argsObjVO[from], bro.id);
    });

    // console.log('UNIQUE', existSet);

    if(existSet.has(fdv.argsObjVO[from])) {
      let existID: number = existSet.get(fdv.argsObjVO[from]);
      if(existID !== fdv.id) {
        result = false;
      }
      
    }

    if (!!result ) {
      mmi.r = '1';
    } else {
      mmi.r = '0';
    }
    // console.log('UNIQUE', fdv.argsObjVO[from], result);
    return result;
  }

  /**
   * Entre le IF et le PREFER
   * Collection de couples test / result si OK
   * si rien n'est correct, retourne null
   *
   * @param mmi Etape de calcul concernée
   */
  public static IFS(mmi: MeasModeItem): void {
    
    let idx: number = 0; // index de base pour prise des premiers champs
    let conditionOK: boolean = false;

    mmi.r = null;
    while(!conditionOK && (idx + 1) <= mmi.c?.length) {

      const val: number = Number(mmi.c[idx].r);
      if (val === 1) {
        conditionOK = true;
        mmi.r = mmi.c[idx + 1].r;
      } else {
        idx = idx + 2;
      }
    }

  }

}
